export default function React_Server() {
  return (
    <div>
      <h1>React_Server Component</h1>
      <p>This is the React_Server tutorial page.</p>
    </div>
  );
}
